import APIClient from './APIClient';

const {
  REACT_APP_ONBOARDING_API_HOST: ONBOARDING_API_HOST,
  REACT_APP_APPLICATIONS_URL: APPLICATIONS_URL,
  REACT_APP_EDIT_APPLICATION_URL: EDIT_APPLICATION_URL,
  REACT_APP_SUBMIT_APPLICATION_URL: SUBMIT_APPLICATION_URL,
  REACT_APP_REJECT_APPLICATION_URL: REJECT_APPLICATION_URL,
  REACT_APP_EDIT_UNSUPPORTED_SCHOOLS_INTEREST_URL: EDIT_UNSUPPORTED_SCHOOLS_INTEREST_URL,
} = process.env;

export const url = `${ONBOARDING_API_HOST}${APPLICATIONS_URL}`;

export const editUrlFor = applicationId =>
  `${ONBOARDING_API_HOST}${EDIT_APPLICATION_URL}`.replace('{applicationId}', applicationId);

export const editUnsupportedSchoolsInterestUrlFor = applicationId =>
  `${ONBOARDING_API_HOST}${EDIT_UNSUPPORTED_SCHOOLS_INTEREST_URL}`.replace(
    '{applicationId}',
    applicationId,
  );

export const submitUrlFor = applicationId =>
  `${ONBOARDING_API_HOST}${SUBMIT_APPLICATION_URL}`.replace('{applicationId}', applicationId);

export const rejectUrlFor = applicationId =>
  `${ONBOARDING_API_HOST}${REJECT_APPLICATION_URL}`.replace('{applicationId}', applicationId);

export default class ApplicationAPI {
  static createApplication = (params, token) => {
    return APIClient.post(
      url,
      {
        ...params,
        productType: 'in_school',
      },
      token,
    ).then(response => response.data);
  };

  static updateApplication = (params, token) => {
    const { id: applicationId, ...otherParams } = params;

    return APIClient.patch(
      editUrlFor(applicationId),
      {
        ...otherParams,
        productType: 'in_school',
      },
      token,
    ).then(response => response.data);
  };

  static updateUnsupportedSchoolsInterest = (params, token) => {
    const { id: applicationId, ...otherParams } = params;

    return APIClient.patch(
      editUnsupportedSchoolsInterestUrlFor(applicationId),
      {
        ...otherParams,
        productType: 'in_school',
      },
      token,
    ).then(response => response.data);
  };

  static submitApplication = (params, token) => {
    const { id: applicationId, ...otherParams } = params;

    return APIClient.patch(
      submitUrlFor(applicationId),
      {
        ...otherParams,
        productType: 'in_school',
      },
      token,
    ).then(response => response.data);
  };

  static rejectApplication = (params, token) => {
    const { id: applicationId, ...otherParams } = params;
    return APIClient.patch(rejectUrlFor(applicationId), { ...otherParams }, token).then(
      response => response.data,
    );
  };
}
